import * as R from 'ramda';
import { getAvailabilityLabel } from '../../../../../../../utils/getAvailabilityLabel';
import { ProductGridTestIds } from '../../../../../../../utils/testIds/productGrid.testIds';
import { useAuthContext } from '../../../../../../login/AuthContext';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import CombinationLine from '../../../CombinationLine/components/CombinationLine/CombinationLine';
import { COMBINATION_WITH_IMAGE_INFO_SECTION_WIDTH } from '../../../CombinationLine/consts/combinationLine.consts';
import { CombinationLineTransformer } from '../../../CombinationLine/transformers/CombinationLineProps.transformer';
import useKitItemCombination from './hooks/useKitIitemCombination';
import { KitItemCombinationProps } from './types/kitItemCombination.types';

const KitItemCombinationListItem = ({ combination }: KitItemCombinationProps) => {
  const { loggedin } = useAuthContext();
  const { translate } = useTranslation();

  const {
    isLoginModalOpen,
    closeLoginModal,
    formattedGrid,
    showSuggestedGrid,
    combinationFormatted,
    suggestedGrid,
    hasValidPacks,
    selectedPacks,
    suggestedPacks,
    suggestionAchieved,
    isFinishedOrder,
    copiedGrid,
    getLimit,
    getStockValue,
    handleOpenProductDetails,
  } = useKitItemCombination({ combination });

  return (
    <CombinationLine
      showProductImage
      gridLength={formattedGrid.length}
      combinationTestId={`${ProductGridTestIds.GRID_COMBINATION}-${combination.productColorCode}-${combination.availability}`}
      isLoggedin={loggedin}
      closeLoginModal={closeLoginModal}
      isLoginModalOpen={isLoginModalOpen}
      imageUrl={combination.mediaUrl}
      infoSectionWidth={COMBINATION_WITH_IMAGE_INFO_SECTION_WIDTH}
      orderProductPriceProps={{
        grid: formattedGrid,
        partsQuantity: R.sum(formattedGrid.map((item) => item.orderItemQuantity ?? 0)),
        isFinishedOrder,
      }}
      productDetailsCombinationColorAndTagsProps={CombinationLineTransformer.toProductDetailsCombinationColorAndTagsProps(
        {
          suggestedGrid,
          showSuggestedGrid,
          showColorIcon: false,
          showProductName: true,
          combination: combinationFormatted,
          onClickProductName: handleOpenProductDetails,
          availabilityLabel: getAvailabilityLabel({
            translate,
            deliveryWindowName: combination.deliveryWindowName,
            availability: combination.availability,
          }),
        },
      )}
      orderProductGridContainerProps={CombinationLineTransformer.toOrderProductGridContainerProps({
        grid: formattedGrid,
        copiedGrid,
        orderStatus: undefined,
        getLimit,
        getStockValue,
        hasValidPacks,
        suggestedGrid,
        selectedPacks,
        suggestedPacks,
        showSuggestedGrid,
        suggestionAchieved,
        disableAll: true,
        hideButtons: true,
        readMode: isFinishedOrder,
        combination: combinationFormatted,
        productSizeNames: formattedGrid.map((item) => item.productSizeName),
      })}
    />
  );
};
export default KitItemCombinationListItem;
